import { render, staticRenderFns } from "./PlanejamentoOrdemServico.vue?vue&type=template&id=50c72952"
import script from "./PlanejamentoOrdemServico.vue?vue&type=script&lang=js"
export * from "./PlanejamentoOrdemServico.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoOrdemServico.vue?vue&type=style&index=0&id=50c72952&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports